import { Button } from "@/components/ui/button";
import heroBackgroundVideo from "@/assets/hero-background.mp4";
import heroBackgroundPoster from "@/assets/hero-background.jpg";
import { trackButtonClick, trackConversion } from "@/lib/analytics";

const Hero = () => {
  const handleCTAClick = () => {
    trackButtonClick('hero_cta', 'homepage');
    trackConversion('hero_cta_click', 1);
    window.location.href = '/contact';
  };

  return (
    <section
      id="hero"
      className="relative md:min-h-screen md:h-screen flex items-center justify-center overflow-hidden pt-20 pb-6 md:py-0"
    >
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        // Poster as cover background: fills the hero while the video loads or when
        // autoplay is blocked (e.g. iOS Low Power Mode), instead of letterboxing
        style={{ backgroundImage: `url(${heroBackgroundPoster})` }}
      >
        <video
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster={heroBackgroundPoster}
          width={1480}
          height={832}
          className="absolute inset-0 w-full h-full object-cover blur-[1px]"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            minWidth: '100%',
            minHeight: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            willChange: 'auto',
          }}
          onLoadedData={(e) => {
            e.currentTarget.style.opacity = '1';
          }}
          aria-label="Bakgrundsvideo som visar modern teknologi och digitalisering"
        >
          <source src={heroBackgroundVideo} type="video/mp4" />
          <track kind="captions" srcLang="sv" label="Svenska" default />
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/60" />
      </div>

      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 md:pt-20">
        <h1 className="text-3xl md:text-6xl lg:text-7xl font-bold mb-4 md:mb-6 leading-snug md:leading-tight drop-shadow-2xl text-balance">
          <span className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)] block">
            <span className="md:block">Din lokala AI partner för</span>{" "}
            <span className="md:block">en smartare vardag</span>
          </span>
        </h1>

        <p className="text-base sm:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto mb-6 md:mb-10 px-2 leading-relaxed drop-shadow-md">
          Skräddarsydd mjukvara, webb och rådgivning för företag — från idé till färdig lösning.
        </p>

        <Button
          variant="hero"
          size="lg"
          className="drop-shadow-lg md:shadow-hero md:h-14 md:px-10 md:text-lg text-sm px-4 max-w-[min(100%,20rem)] whitespace-normal h-auto min-h-12 py-3"
          onClick={handleCTAClick}
        >
          Boka kostnadsfritt möte idag
        </Button>

        {/* Scroll indicator, mobile: in the flow below the CTA so it never overlaps it */}
        <div className="md:hidden mt-5 flex justify-center animate-bounce" aria-hidden="true">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/50 rounded-full mt-2" />
          </div>
        </div>
      </div>

      {/* Scroll indicator, desktop: pinned to the bottom of the hero */}
      <div
        className="hidden md:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce"
        aria-hidden="true"
        style={{ left: 'calc(50% - 10px)' }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-white/50 rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
